function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M16 32C7.163 32 0 24.837 0 16S7.163 0 16 0s16 7.163 16 16-7.163 16-16 16zm0-2c7.732 0 14-6.268 14-14S23.732 2 16 2 2 8.268 2 16s6.268 14 14 14zm6.207-20.61a1 1 0 1 1 1.586 1.22l-10 13a1 1 0 0 1-1.5.097l-4-4a1 1 0 1 1 1.414-1.414l3.195 3.195L22.207 9.39z"
});

var SvgAlertSuccess = function SvgAlertSuccess(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "#1B1F23",
    viewBox: "0 0 32 32"
  }, props), _ref);
};

export default __webpack_public_path__ + "af2e80cfaeda348c73d17b574a170e4f.svg";
export { SvgAlertSuccess as ReactComponent };


//////////////////
// WEBPACK FOOTER
// ../icons/svg/alert-success.svg
// module id = null
// module chunks = 